import { createAction, props } from '@ngrx/store';
import { Tag } from '../_models/tag';

// Action types
export const loadTags = createAction('[Tag] Load Tags');
export const loadTagsSuccess = createAction('[Tag] Load Tags Success', props<{ tags: Tag[] }>());
export const loadTagsFailure = createAction('[Tag] Load Tags Failure', props<{ error: any }>());

export const addTag = createAction('[Tag] Add Tag', props<{ tag: Tag }>());
export const addTagSuccess = createAction('[Tag] Add Tag Success', props<{ tag: Tag }>());
export const addTagFailure = createAction('[Tag] Add Tag Failure', props<{ error: any }>());

export const updateTag = createAction('[Tag] Update Tag', props<{ tag: Tag }>());
export const updateTagSuccess = createAction('[Tag] Update Tag Success', props<{ tag: Tag }>());
export const updateTagFailure = createAction('[Tag] Update Tag Failure', props<{ error: any }>());

export const deleteTag = createAction('[Tag] Delete Tag', props<{ id: number }>());
export const deleteTagSuccess = createAction('[Tag] Delete Tag Success', props<{ id: number }>());
export const deleteTagFailure = createAction('[Tag] Delete Tag Failure', props<{ error: any }>());
